import React from 'react';
import { FaGithub, FaLinkedin, FaTwitter, FaMedium } from 'react-icons/fa';

const Footer = () => {

    const d = new Date();
    const currentYear = d.getFullYear();

    return (
    <footer className="container copyright">
    <p>&copy; Copyright Luka Baramishvili {currentYear} | Made with ♡ in NY </p>
    <p className='network-logos'>
      <a href="https://www.linkedin.com/in/luka-baramishvili/" 
         target='_blank' 
         rel="noopener noreferrer"><FaLinkedin />
      </a>
      <a href="https://github.com/lukabaramishvili" 
         target='_blank' 
         rel="noopener noreferrer"><FaGithub />
      </a>
      <a href="https://twitter.com/lukabaram" 
         target='_blank' 
         rel="noopener noreferrer"><FaTwitter />
      </a>
       <a href="https://medium.com/@lukabaramishvili" 
         target='_blank' 
         rel="noopener noreferrer"><FaMedium />
      </a>
    </p>
  </footer>
    )
}

export default Footer;
